import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
const destinations = [{
  id: 1,
  name: 'Turkey',
  image: 'https://images.unsplash.com/photo-1589561454226-796a8aa89b05?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1169&q=80',
  description: 'Discover the beauty of Istanbul, Cappadocia, and the Turkish Riviera'
}, {
  id: 2,
  name: 'Dubai',
  image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
  description: 'Experience luxury and adventure in the city of gold'
}, {
  id: 3,
  name: 'Thailand',
  image: 'https://images.unsplash.com/photo-1528181304800-259b08848526?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
  description: 'Explore tropical beaches and ancient temples'
}, {
  id: 4,
  name: 'Malaysia',
  image: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1164&q=80',
  description: 'Visit Kuala Lumpur, Penang, and beautiful island resorts'
}];
const PopularDestinations = () => {
  return <section className="py-16 bg-gray-50" data-id="element-210">
      <div className="container mx-auto px-4" data-id="element-211">
        <div className="flex justify-between items-center mb-12" data-id="element-212">
          <h2 className="text-3xl font-bold text-gray-900" data-id="element-213">
            Popular Destinations
          </h2>
          <Link to="/destinations" className="flex items-center text-red-600 hover:text-red-800" data-id="element-214">
            View all destinations
            <ArrowRightIcon size={16} className="ml-2" data-id="element-215" />
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-216">
          {destinations.map(destination => <div key={destination.id} className="bg-white rounded-lg shadow-md overflow-hidden transition-transform hover:scale-105" data-id="element-217">
              <div className="h-48 overflow-hidden" data-id="element-218">
                <img src={destination.image} alt={destination.name} className="w-full h-full object-cover" data-id="element-219" />
              </div>
              <div className="p-6" data-id="element-220">
                <h3 className="text-xl font-semibold mb-2" data-id="element-221">
                  {destination.name}
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-222">{destination.description}</p>
                <Link to={`/destinations/${destination.id}`} className="inline-block text-red-600 hover:text-red-800 font-medium" data-id="element-223">
                  Explore packages →
                </Link>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default PopularDestinations;